import { render, staticRenderFns } from "./screenTriviaCityTilesGame.vue?vue&type=template&id=4ef5aee0&"
import script from "./screenTriviaCityTilesGame.vue?vue&type=script&lang=js&"
export * from "./screenTriviaCityTilesGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports